<template>
  <div class="imgsort-list">
    <el-backtop target="#index-page"></el-backtop>
    <div class="label-search-wrap">
      <div class="label-search">
        <div class="label">国籍：</div>
        <div class="paintList">
          <div class="tag" :class="item.selected ? 'selected' : ''" v-for="item in countryList" :key="item.code" @click="selectCountry(item)">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="label-search">
        <div class="label">画派：</div>
        <div class="paintList">
          <div class="tag" :class="item.selected ? 'selected' : ''" v-for="item in paintList" :key="item.code" @click="selectPaint(item)">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="label-search">
        <div class="label">推荐：</div>
        <div class="paintList">
          <div class="tag" :class="item.selected ? 'selected' : ''" v-for="item in recommendList" :key="item.code" @click="selectRecommend(item)">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="imgList.length" class="img-list">
      <div class="item" v-for="(item, index) in imgList" :key="item.designId">
        <div class="authorInfo">
          <div class="img">
            <img :src="item.authorPicUrl || authorPhoto" alt="" />
          </div>
          <div class="text">
            <div class="name">IP名称：{{ item.authorName }}</div>
            <!-- <div class="name-en">英文名：{{ item.realNameEn }}</div> -->
            <!-- <div class="name">国籍：{{ item.nationalityName }}</div> -->
            <div class="date">IP简介：{{ item.remark }}</div>
          </div>
          <div class="btn-group">
            <div v-show="item.vedioSourceUrl" class="btn" @click="download(item.vedioSource)">
              下载文案资料
            </div>
            <div class="btn" @click="goAuthorAllDesign(item)">
              展示全部个人作品
            </div>
          </div>
          <div class="img-group">
            <div class="ip-img">
              <template v-if="item.designs.length">
                <div class="designImg" @click="showImg(itemChild)" v-for="itemChild in item.designs" :key="itemChild.designId" :style="`background: url(${itemChild.designUrl + '?x-oss-process=image/resize,w_200'}) no-repeat center center / contain`">
                  <!-- <img object-fit="contain" :src="itemChild.designUrl + '?x-oss-process=image/resize,w_200'" alt="" /> -->
                </div>
              </template>
              <div class="no-data" v-else>该作者暂无作品</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="list-no-data">
      暂无数据
    </div>
    <div class="site-page">
      <el-pagination background :total="total" :current-page.sync="pageNum" @current-change="getImgList" layout="prev, pager, next, jumper"></el-pagination>
    </div>
    <el-dialog width="500px" title="防伪码选择" :visible.sync="innerVisible" @close="clearBuyOption" :close-on-click-modal="false" append-to-body>
      <div class="buy-option">
        <div class="title">防伪码区域</div>
        <el-radio-group v-model="buyOption.code">
          <el-radio-button label="1">国内防伪码</el-radio-button>
          <el-radio-button label="2">国外防伪码</el-radio-button>
        </el-radio-group>
      </div>
      <div class="buy-option">
        <div class="title" style="margin-top:20px;">购买数量</div>
        <el-input-number v-model="buyOption.num" :min="1" style="width:192px;" @change="numChange"></el-input-number>
      </div>
      <div class="buy-option">
        <div class="title" style="margin-top:20px;">总价</div>
        <div class="totalPrice" style="color:#409EFF;">￥{{ buyOption.total }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" @click="buy">立即购买</el-button>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogVisible" width="500px">
      <div class="currentImg">
        <img :key="currentItem.designId" :src="currentItem.designUrl" alt="" />
      </div>
      <div class="authorDesc">
        <div class="countryType">艺术家：{{ currentItem.author.authorName }}</div>
        <div class="countryType">作品名：{{ currentItem.name }}</div>
        <div class="countryType">版权归属：{{ currentItem.authorInfo || currentItem.author.authorName }}</div>
        <div class="categoryName">授权品类：{{currentItem.extAuthTypeNames.join('、')}}</div>
        <div class="categoryName">设计要求：{{currentItem.designRequirementName}}{{currentItem.designRequirement ? `(${currentItem.designRequirement})` : ''}}</div>
        <div class="categoryName">推广应用：{{currentItem.extensionAppNames.join('、')}}</div>
        <div class="name" style="margin-bottom:2px;">简介</div>
        <div v-if="currentItem.remark" class="desc">{{ currentItem.remark }}</div>
        <div v-else class="no-data">暂无简介</div>
        <div class="btn-gourp" style="width:300px;margin: 20px auto 0;">
          <el-button type="primary" size="small" icon="el-icon-download" @click="download(currentItem.designPdf, currentItem.designId)">下载原图</el-button>
          <el-button v-show="currentItem.introduceFile" type="primary" size="small" icon="el-icon-download" @click="download(currentItem.introduceFile)">下载文案</el-button>
          <el-button type="primary" v-if="shopId != currentItem.shopId" size="small" icon="el-icon-goods" @click="innerVisible = true">购买授权</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API, { baseUrl } from '../lib/API'
export default {
  name: 'OrderList',
  data() {
    return {
      currentPage1: 2,
      pageNum: 2,
      total: 0,
      content: '',
      paintStyle: '',
      recommendStyle: '',
      nationality: '',
      isBrand: true,
      innerVisible: false,
      shopId: '',
      categoryLoading: false,
      name: '',
      imgList: [],
      dialogVisible: false,
      currentImg: '',
      authorPhoto: require('../assets/author.png'),
      buyOption: {
        code: '',
        num: 1,
        price: 1,
        total: 1 * 1
      },
      currentItem: {
        introduceFile: '',
        author: {},
        extAuthTypeNames: [],
        extensionAppNames: [],
      },
      paintList: [],
      recommendList: [],
      countryList: [],
      allTagShow: false,
      selectedTagName: ''
    }
  },
  computed: {
    categoryDisabled() {
      if (this.dataType === '1' || (this.dataType === '2' && this.shopId)) {
        return false
      }
      return true
    }
  },
  methods: {
     handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
    download(designPdf, designId) {
      let a = document.createElement('a')
      a.href = `${baseUrl}/download/image?key=${designPdf}&designId=${designId || 
      ''}&accesstoken=${localStorage.getItem('token')}`
      a.click()
    },
    numChange(num) {
      this.buyOption.total = this.buyOption.price * (num || 0)
    },
    buy() {
      if (!this.buyOption.num) return this.$message.error('请输入购买数量')
      if (!this.buyOption.code) return this.$message.error('请选择防伪码区域')
      this.$router.push({ name: 'OrderConfirm', query: { count: this.buyOption.num, total: this.buyOption.total, code: this.buyOption.code, price: this.currentItem.price, designId: this.currentItem.designId, ipImgUrl: this.currentItem.designUrl + '?x-oss-process=image/resize,w_200' } })
    },
    clearBuyOption() {
      this.buyOption = {
        code: '',
        num: 1,
        price: 1,
        total: 1 * 1
      }
    },
    clearSelected(list) {
      list.forEach(item => {
        item.selected = false
      })
    },
    goAuthorAllDesign(item) {
      if (!item.designs.length) {
        return this.$message.error('该作者暂无作品')
      }
      window.open(`${window.location.origin}/authorAllDesign?authorId=${item.authorId}`)
      // this.$router.push({ name: 'AuthorAllDesign', query: { authorId: item.authorId } })
    },
    selectPaint(item) {
      this.clearSelected(this.paintList)
      item.selected = true
      this.paintStyle = item.code
      this.getImgList()
    },
    selectRecommend(item) {
      this.clearSelected(this.recommendList)
      item.selected = true
      this.recommendStyle = item.code
      this.getImgList()
    },
    selectCountry(item) {
      this.clearSelected(this.countryList)
      item.selected = true
      this.nationality = item.code
      this.getImgList()
    },
    getCountryList() {
      new API(this).POST({
        url: '/select/findCountryList',
        cb: res => {
          res.forEach(item => {
            item.selected = false
          })
          res.unshift({ name: '全部', code: '', selected: true })
          this.countryList = res
        }
      })
    },
    getPaintList() {
      new API(this).POST({
        url: '/select/findPaintList',
        cb: res => {
          res.forEach(item => {
            item.selected = false
          })
          res.unshift({ name: '全部', code: '', selected: true })
          this.paintList = res
        }
      })
    },
    getRecommendList() {
      new API(this).POST({
        url: "/select/findRecommendTagList",
        cb: res => {
          res.forEach(item => {
            item.selected = false
          })
          res.unshift({ name: '全部', code: '', selected: true })
          this.recommendList= res;
        }
      });
    },
    showImg(item) {
      this.buyOption.price = item.price || 1
      this.dialogVisible = true
      new API(this).POST({
        url: '/design/getDesignDetail?designId=' + item.designId,
        cb: res => {
          this.currentItem = res
        }
      })
    },
    btnGetImgList() {
      this.clearSelected()
      this.getImgList()
    },
    tagSelectGetImgList() {
      this.getImgList()
    },
    getImgList(val) {
      if (!isNaN(val)) {
        this.pageNum = val
      } else {
        this.pageNum = 1
      }
      if (this.$route.query.pageNum != this.pageNum) {
        this.$router.replace({query: {pageNum: this.pageNum}})
      }
      let params = {
        nationality: this.nationality,
        paintIds: this.paintStyle ? [this.paintStyle] : [],
        recommendTagIds: this.recommendStyle ? [this.recommendStyle] : [],
        count: true,
        pageNum: this.pageNum,
        pageSize: 10
      }
      window.scroll(0, 0)
      new API(this).POST({
        url: '/author/manageWithPage',
        params,
        cb: res => {
          let { total, result } = res
          result.forEach(element => {
            element.load = false
          })
          this.total = Number(total)
          this.imgList = result
          document.getElementById('index-page').scrollTop = 0
        }
      })
    }
  },
  created() {
    this.pageNum = this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1
    this.getCountryList()
    this.getPaintList()
    this.getRecommendList()
    this.getImgList(this.pageNum)
  },
  beforeDestroy() {}
}
</script>
<style scoped lang="less">
.imgsort-list {
  width: 1200px;
  margin: 0 auto;
}
.showAllBtn {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 5px;
  top: 20px;
  width: 40px;
  height: 40px;
  font-size: 24px;
  color: #409eff;
  cursor: pointer;
}
.label-search {
  display: flex;
  margin-bottom: 20px;
  .label {
    width: 50px;
  }
  .paintList {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    .tag {
      margin: 0 15px 8px;
      cursor: pointer;
    }
    .selected {
      color: #409eff;
    }
  }
}
.label-search-wrap {
  width: 100%;
  position: relative;
  padding: 0 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.all-tag-show {
  max-height: 500px;
}
.my-tab /deep/ .el-tabs__item {
  width: 50%;
  text-align: center;
  font-size: 18px;
}
.my-tab /deep/ .el-tabs__nav {
  width: 100%;
}
.currentImg {
  width: 100%;
  // height: 500px;
  // border: 1px solid #f1f1f1;
  img {
    width: 100%;
  }
}
.buy-option {
  margin-bottom: 20px;
}
.title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
}
.btn-gourp {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.my-btn-black {
  background: #000;
}
.authorDesc {
  line-height: 34px;
  color: rgb(85, 83, 83);
  font-size: 16px;
  padding: 5px 10px;
  .name {
    font-weight: bold;
    font-size: 18px;
    color: #000;
    margin: 10px 0;
  }
  .price {
    color: orange;
  }
  .desc {
    background: #f1f1f1;
    padding: 10px;
    border-radius: 8px;
    margin: 6px 0 0;
  }
  .author-info {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .author-pic {
      width: 60px;
      height: 60px;
      margin-right: 15px;
      img {
        width: 100%;
        height: 100%;
      }
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    .author-text {
      .author-name {
        font-weight: bold;
        font-size: 16px;
        color: #000;
      }
    }
  }
}
.browse {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 5px 10px;
  margin-bottom: 20px;
  border-radius: 5px;
  margin-top: 10px;
  .name {
    width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  i {
    margin-right: 10px;
  }
}
.img-list {
  // display: flex;
  // flex-wrap: wrap;
  .item {
    transition: all 0.4s;
    background: #f1f0f0;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 10px 20px;
    margin-top: 30px;
    .authorInfo {
      display: flex;
      align-items: center;
      display: flex;
      justify-content: space-between;
      .img {
        width: 200px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        background: #fff;
        box-sizing: border-box;
        border-radius: 5px;
        // margin-bottom: 10px;
        position: relative;
        height: 200px;
        img {
          width: 100%;
          height: 200px;
          // position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
    .text {
      line-height: 40px;
      margin-left: 20px;
      width: 300px;
      & > .date {
        display: -webkit-box;
        width: 100%;
        overflow: hidden;
        -webkit-line-clamp: 4;
        line-height:28px;
        // height: 120px;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        // white-space: nowrap;
      }
    }
    .btn-group {
      margin-left: 20px;
      .btn {
        width: 150px;
        border-radius: 5px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        background: #409eff;
        color: #fff;
        transition: all 0.4s;
        cursor: pointer;
        &:last-child {
          margin-bottom: 0;
        }
        &:hover {
          opacity: 0.8;
        }
      }
    }
    .ip-img {
      width: 390px;
      height: 200px;
      display: flex;
      margin-left: 20px;
      align-items: center;
      .designImg {
        width: 120px;
        height: 200px;
        border: 1px solid #fefefe;
        margin-left: 10px;
        cursor: pointer;
      }
      img {
        // width: 100%;
        // height: 200px;
        cursor: pointer;
      }
    }
    &:hover {
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    }
    .no-data {
      color:#333;
      font-size:14px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex:1;
    }
  }
}
 .list-no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    font-size: 16px;
    color:rgb(179, 174, 174);
  }
</style>



// WEBPACK FOOTER //
// src/components/AuthorList.vue